import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Layout, Input, Button, Form, Card, Divider, List } from "antd";
import {} from "./MetalsPageService";
import Loader from "../../components/Loader/Loader";
import "./MetalsPage.css";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import Copyright from "../../components/Copyright/Copyright";
import { removeTokenFromCookies } from "../../utils/cookies";
import { getMetalsService, getCategoriesService, postMetalService } from "../MetalsPage/MetalsPageService";
import MetalForm from "../../components/MetalForm/MetalForm";
import Cookies from "universal-cookie";

const { Content } = Layout;

export interface MetalsPageInterface {}

const MetalsPage = (props: MetalsPageInterface) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [metals, setMetals] = useState([]);
  const [categories, setCatgeories] = useState([]);
  const [showMetalForm, setShowMetalForm] = useState(false);
  const navigate = useNavigate();
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");

  useEffect(() => {
    navToSelectOffice();
    getCategories();
    getMetals();
  }, []);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getCategories = async () => {
    try {
      setLoading(true);
      const res = await getCategoriesService();
      setCatgeories(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getCategories error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postMetal = async (metalInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        name: metalInfo.name.trim(),
        displayName:
          metalInfo.displayName === "" || metalInfo.displayName === null || metalInfo.displayName === undefined
            ? metalInfo.name.trim()
            : metalInfo.displayName.trim(),
        categoryID: metalInfo.categoryID,
      };
      const res = await postMetalService(payload);
      setTimeout(async () => {
        setLoading(false);
        await getMetals();
      }, 1000);
    } catch (e: any) {
      setLoading(false);
      console.error("postMetal error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const openMetalForm = () => {
    setShowMetalForm(true);
  };

  const closeMetalForm = () => {
    setShowMetalForm(false);
  };

  const getCategoryName = (categoryID: string) => {
    let categoryDetails: any = categories.find((category: any) => category.categoryID === categoryID);
    return categoryDetails !== undefined ? categoryDetails.name : "";
  };

  const displayMetalsCategories = () => {
    let categoristMap: any = {};
    categories.forEach((category: any) => (categoristMap[category.categoryID] = []));
    metals.forEach((metal: any) => {
      categoristMap[metal.categoryID].push(metal);
    });
    return Object.entries(categoristMap).map(([key, value]: any) => {
      return (
        <Col span={6}>
          <Card title={getCategoryName(key)} bordered={false} style={{ margin: "10px" }} bodyStyle={{ padding: "5px" }}>
            <List
              style={{ padding: "10px" }}
              dataSource={value}
              grid={{ column: 2 }}
              itemLayout="vertical"
              renderItem={(item: any) => <List.Item style={{ margin: "5px" }}>{item.displayName}</List.Item>}
            />
          </Card>
        </Col>
      );
    });
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row>
              <Col span={12}>
                <Row justify="start">
                  <h2 className="metals-title">Metals</h2>
                </Row>
              </Col>
              <Col span={12}>
                <Row justify="end" style={{ marginTop: "20px" }}>
                  <Button type="primary" onClick={() => openMetalForm()}>
                    Add New Metal
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Row className="metals-list">{displayMetalsCategories()}</Row>
          </Col>
        </Row>
        <MetalForm
          showForm={showMetalForm}
          closeForm={closeMetalForm}
          editMetalData={null}
          postMetal={postMetal}
          categories={categories}
        />
        <Copyright />
      </Content>
    </Layout>
  );
};

export default MetalsPage;
